import React from "react";

function ImageNotFound() {
  return (
    <div className="d-flex justify-content-center align-items-center image-not-found text-center">
      <div>
        <i className="simple-icon-camera" />
        <h4>Image Not Found!</h4>
      </div>
    </div>
  );
}

export default ImageNotFound;
